<div class="scrollable-table-container">
  <table mat-table [dataSource]="properties" class="table table-primary-color">

    <ng-container matColumnDef="tipo">
      <th mat-header-cell *matHeaderCellDef> Tipo di proprietà </th>
      <td mat-cell *matCellDef="let element"> {{element.tipo}} </td>
    </ng-container>

    <ng-container matColumnDef="comune">
      <th mat-header-cell *matHeaderCellDef> Località </th>
      <td mat-cell *matCellDef="let element"> {{element.comune}} </td>
    </ng-container>

    <ng-container matColumnDef="valoreStimato">
      <th mat-header-cell *matHeaderCellDef> Rendita catastale </th>
      <td mat-cell *matCellDef="let element"> {{element.valoreStimato | currency:'EUR':'symbol':'1.2-2':'it'}} </td>
    </ng-container>

    <ng-container matColumnDef="percentuale">
      <th mat-header-cell *matHeaderCellDef> Percentuale di proprietà </th>
      <td mat-cell *matCellDef="let element"> {{(element.percentuale || '0') + '%'}} </td>
    </ng-container>

    <ng-container matColumnDef="gravame">
      <th mat-header-cell *matHeaderCellDef> Tipo di gravame </th>
      <td mat-cell *matCellDef="let element"> {{element.gravame}} </td>
    </ng-container>

    <ng-container matColumnDef="debito">
      <th mat-header-cell *matHeaderCellDef> Debito residuo </th>
      <td mat-cell *matCellDef="let element"> {{element.debito | currency:'EUR':'symbol':'1.2-2':'it'}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="!praticaService.isFrozenOrConfermata" mat-icon-button class="icon-button"
          aria-label="Modifica immobile" matTooltip="Modifica immobile" (click)="patchForm(element)">
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
        <button *ngIf="!praticaService.isFrozenOrConfermata" mat-icon-button class="icon-button"
          aria-label="Elimina immobile" matTooltip="Elimina immobile" (click)="deleteProperty(element)">
          <mat-icon svgIcon="delete"></mat-icon>
        </button>
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" style="text-align: center; padding: 20px 0;" colspan="7">Nessun immobile presente al momento.
      </td>
    </tr>
  </table>
</div>